// extracted by mini-css-extract-plugin
export var current = "Breadcrumbs-module--current--abd98";
export var layout = "Breadcrumbs-module--layout--83743";
export var link = "Breadcrumbs-module--link--550e7";
export var visible = "Breadcrumbs-module--visible--77301";
export var wrapper = "Breadcrumbs-module--wrapper--b3bed";